
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import _getPrototypeOf from './getPrototypeOf.js';
import _isNativeReflectConstruct from './isNativeReflectConstruct.js';
import _possibleConstructorReturn from './possibleConstructorReturn.js';

function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}

export { _createSuper as default };
//# sourceMappingURL=createSuper.js.map
